import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Severity } from '../../services/flash-messages/flash-message.model';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { VideoRequestsService } from '../../services/video-requests/video-requests.service';
import { ViewVideoRequest } from '../../services/video-requests/view-video-request.model';
import { ReturnUrlService } from '../../services/return-url/return-url.service';

@Component({
    selector: 'app-video-requests',
    templateUrl: './video-requests.component.html',
    styleUrls: ['./video-requests.component.css']
})
export class VideoRequestsComponent implements OnInit, OnDestroy {
    messageIds = {
        newRequest: <string>null
    };

    newVrrId: number;
    requests: ViewVideoRequest[];

    constructor(private flashMessagesService: FlashMessagesService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private returnUrlService: ReturnUrlService,
        private videoRequestsService: VideoRequestsService) {
            this.returnUrlService.save();
    }

    ngOnDestroy(): void {
        this.flashMessagesService.clear(this.messageIds.newRequest);
    }

    async ngOnInit(): Promise<void> {
        this.requests = await this.videoRequestsService.all();
        const vrrIdString = this.activatedRoute.snapshot.paramMap.get('vrrId');

        if (vrrIdString) {
            this.newVrrId = parseInt(vrrIdString, 10);

            const request = this.requests.find((value: ViewVideoRequest) => value.vrrId === this.newVrrId);

            if (request) {
                const name = request.requestName + (request.requestName.endsWith('.') ? '' : '.');
                const preface = 'Video request submitted successfully:';
                this.messageIds.newRequest = this.flashMessagesService.addMessage(Severity.Success, name, preface);
            }
        }
    }

    showDetails(request: ViewVideoRequest): void {
        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate(['video-request', request.requestId]);
    }
}
